var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "editorial-wall" },
    [
      (_vm.isMobile || _vm.isHeaderMobile) && _vm.titleIsVisible
        ? [_c("div", { staticClass: "wall__title" }, [_vm._t("title")], 2)]
        : _vm._e(),
      _vm._v(" "),
      _vm.elementsExist
        ? _c(
            "div",
            {
              staticClass: "wall__elements",
              class: { "wall__elements--with-banner": _vm.bannerExists },
            },
            [
              !_vm.isMobile && !_vm.isHeaderMobile
                ? [
                    _c(
                      "div",
                      { staticClass: "wall__title" },
                      [_vm._t("title")],
                      2
                    ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "wall__products",
                  class: {
                    "wall__products--6-elements":
                      _vm.isMobile && _vm.numberOfProducts <= 6,
                    "wall__products--10-elements":
                      _vm.isMobile && _vm.numberOfProducts === 10,
                    "wall__products--with-banner": _vm.bannerExists,
                  },
                },
                [_vm._t("wall-products")],
                2
              ),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isMobile && !_vm.isHeaderMobile
        ? _c("div", { staticClass: "wall__banner" }, [_vm._t("wall-banner")], 2)
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }